// ─── Formatting helpers (exact match reference) ───
export const fmt = (n) => (n < 0 ? "-" : "") + "$" + Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtK = (n) => (n < 0 ? "-" : "") + "$" + (Math.abs(n) >= 1000 ? (Math.abs(n) / 1000).toFixed(1) + "k" : Math.abs(n).toFixed(0));
export const fmtPct = (n) => (n * 100).toFixed(1) + "%";

// Map internal filing status code to compact display abbreviation
// single -> S | married (MFJ) -> MFJ | mfs -> MFS | hoh -> HoH | qss -> QSS
export const fmtFiling = (filing) => {
  if (!filing) return "—";
  const key = String(filing).toLowerCase().trim();
  const map = {
    single: "S",
    s: "S",
    married: "MFJ",
    mfj: "MFJ",
    "married-jointly": "MFJ",
    "married filing jointly": "MFJ",
    mfs: "MFS",
    "married-separately": "MFS",
    "married filing separately": "MFS",
    hoh: "HoH",
    "head of household": "HoH",
    qss: "QSS",
    "qualifying surviving spouse": "QSS",
  };
  return map[key] || String(filing).toUpperCase();
};

// ─── Phone number formatting ───
export const formatPhone = (value) => {
  if (!value) return '';
  
  // Remove all non-digits
  const cleaned = value.replace(/\D/g, '');
  
  // Format as (999) 999-9999
  if (cleaned.length <= 3) {
    return cleaned;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
};

export const cleanPhone = (value) => {
  // Remove formatting, keep only digits
  return value.replace(/\D/g, '');
};
